import React, {forwardRef} from "react";
import {createUseStyles} from "react-jss";

const useStyles = createUseStyles(({ colors }) => ({
  adminIconBar: {},
}))

export const AdminIconBar = forwardRef(({ className = "", style, children, ...rest }, ref) => {
  const classes = useStyles();
  return (
    <div ref={ref} className={`${classes.adminIconBar} ${className}`} style={style} {...rest}>
      {children}
    </div>
  );
});

